import PropTypes from 'prop-types';
import React from 'react';

import Box        from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button     from '@mui/material/Button';

import Display from 'components/Generic/Display';

function Paginator({ page, pages, total, showCount, count, onChange }) {

  if (count === 0) return null;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row-reverse'}}>
      <Box sx={{ display: 'flex' }}>
        <Display if={pages > 1}>
          <Display if={page > 1}>
            <Button sx={{ py: 0, px: 1, m: 0, minWidth: '5px', fontWeight: 'light' }} onClick={() => onChange('page', 1)} data-testid="first-page">{t('eos.company.listings.page.button.first')}</Button>
            <Button sx={{ py: 0, px: 1, m: 0, minWidth: '5px', fontWeight: 'light' }} onClick={() => onChange('page', page - 1)} data-testid="previous-page">{ page - 1 }</Button>
          </Display>

          <Typography sx={{ textDecoration: 'underline', px: 1, fontWeight: 'light' }}>{ page }</Typography>

          <Display if={page < pages}>
            <Button sx={{ py: 0, px: 1, m: 0, minWidth: '5px', fontWeight: 'light' }} onClick={() => onChange('page', page + 1)} data-testid="next-page">{ page + 1 }</Button>
            <Button sx={{ py: 0, px: 1, m: 0, minWidth: '5px', fontWeight: 'light' }} onClick={() => onChange('page', pages)} data-testid="last-page">{t('eos.company.listings.page.button.last')}</Button>
          </Display>
        </Display>
      </Box>

      <Display if={showCount && count}>
        <Typography variant="p" sx={{ fontWeight: 'light', fontStyle: 'italic' }} data-testid="records-count">{t('eos.company.listings.page.label.job_count', { count: count, total: total})}</Typography>
      </Display>
    </Box>
  );
}

Paginator.defaultProps = {
  page:      null,
  pages:     null,
  total:     null,
  showCount: false,
  count:     null,
  onChange:  null,
};

Paginator.propTypes = {
  page:      PropTypes.number,
  pages:     PropTypes.number,
  total:     PropTypes.number,
  showCount: PropTypes.bool,
  count:     PropTypes.number,
  onChange:  PropTypes.func,
};

export default Paginator;
